module.exports = __webpack_public_path__ + "static/media/plus.6a67897e.svg";